/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Steamfitter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TaskIterationTermination = 'IterationCount' | 'UntilSuccess' | 'UntilFailure';

export const TaskIterationTermination = {
    IterationCount: 'IterationCount' as TaskIterationTermination,
    UntilSuccess: 'UntilSuccess' as TaskIterationTermination,
    UntilFailure: 'UntilFailure' as TaskIterationTermination
};

